/* mm-megamenu.js — Megamenú de dos paneles (raíl de secciones + subcategorías).
   Mantiene ACTIVA la sección elegida hasta que se elige otra, marcando la fila
   con la clase .mm-active. Así el puntero puede viajar desde el raíl hasta el
   panel derecho en diagonal SIN que la sección desaparezca (evita el clásico
   "diagonal problem" del hover puro en CSS).
   Reversible: borra este archivo y su <script> en snippets/stylesheets.liquid. */
(function () {
  function rowsWithSubmenu(list) {
    var cols = list.querySelectorAll(':scope > .mega-menu__column');
    var rows = [];
    for (var i = 0; i < cols.length; i++) {
      if (cols[i].querySelector(':scope > div > ul')) rows.push(cols[i]);
    }
    return rows;
  }

  function initList(list) {
    if (list.dataset.mmTwopane) return;
    if (!list.querySelector('.mega-menu__link--parent')) return; // sólo menús con secciones
    var rows = rowsWithSubmenu(list);
    if (!rows.length) return;

    function activate(row) {
      for (var i = 0; i < rows.length; i++) {
        rows[i].classList.toggle('mm-active', rows[i] === row);
      }
    }

    var timer = null;
    rows.forEach(function (row) {
      // pointerenter: intención de abrir esa sección (pequeño colchón anti-parpadeo)
      row.addEventListener('pointerenter', function () {
        if (timer) { clearTimeout(timer); timer = null; }
        activate(row);
      });
      // teclado / accesibilidad
      row.addEventListener('focusin', function () { activate(row); });
    });

    activate(rows[0]);              // por defecto, primera sección con contenido
    list.dataset.mmTwopane = '1';   // desactiva el fallback CSS
  }

  function run() {
    var lists = document.querySelectorAll('.mega-menu__list');
    for (var i = 0; i < lists.length; i++) initList(lists[i]);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  setTimeout(run, 600);
  setTimeout(run, 1500);

  // La cabecera puede re-renderizarse (Section Rendering API): inicializa al vuelo.
  document.addEventListener('pointerover', function (e) {
    var t = e.target;
    var list = t && t.closest ? t.closest('.mega-menu__list') : null;
    if (list) initList(list);
  }, true);
})();
